import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'NavigationTab',
  props: {
    active: { type: [Boolean, null], default: null }
  },
  setup(__props: any) {

const props = __props as { active: boolean | null };



return { __sfc: true,props }
}

})